<template>
    <enrich-contact
        v-if="contact.catchlight_enrichment_status.status === 'not_started' && !enrichmentStarted"
        :contact="contact"
        @enrich-contact="enrichContact(contact)"
        @get-catchlight="getCatchlight"
    >
    </enrich-contact>

    <button
        v-else-if="contact.catchlight_enrichment_status.status === 'in_progress' || enrichmentStarted"
        type="button"
        class="btn btn-lg btn-warning"
    >
        Enriching...
        <i class="fad fa-spinner fa-pulse"></i>
    </button>

    <!-- @click="fetchEnrichmentData(contact)" -->
    <button v-else-if="contact.catchlight_enrichment_status.status === 'completed'" type="button"
            class="btn btn-lg btn-success">
        Enriched
        <i class="fas fa-hand-holding-usd"></i>
    </button>

    <button v-else type="button" class="btn btn-lg btn-danger"
            v-tooltip=contact.catchlight_enrichment_status.explanation>
        Failed
    </button>
</template>

<script>
import {performEnrichContactAction} from '../../../utility/api/contact/enrichContactAction';
import EnrichContact from '../../EnrichContact.vue';

export default {
    name: 'contact-enrich-button',
    components: {
        EnrichContact
    },
    props: {
        contact: {
            type: Object,
            required: true
        }
    },
    data() {
        return {
            isEnabled: false,
            isConnected: false,
            enrichmentStarted: false,
            disableSubmit: false,
        }
    },
    mounted() {
        const self = this;

        self.getCatchlight();

        self.$root.$on('enrichment-complete', (notification) => {
            if (notification.contact_id === self.contact.id) {
                self.enrichmentStarted = false;
            }
        });
    },
    methods: {
        async getCatchlight() {
            try {
                const {data: {data}} = await axios.get('/api/?entity=vessel&action=getCatchlight')
                this.setCatchlightData(data)
            } catch (e) {
                console.log(e);
            }
        },
        enrichContact() {
            if (!this.isConnected || !this.isEnabled || !this.contact.can_be_enriched) {
                if (confirm("Your Catchlight connection has timed out. Proceed to the account page to reconnect.") === true) {
                    window.location.href = `/account/catchlight?redirect_url=${window.location.href}`;
                }

                return;
            }

            performEnrichContactAction(this.contact.id).then(response => {
                this.enrichmentStarted = true;
            });
        },
        setCatchlightData(data) {
            this.isConnected = data.is_connected
            this.isEnabled = data.is_enabled
        },
    }
}
</script>

<style lang="scss" scoped>

</style>
